export default __webpack_public_path__ + "hero-xl-5b24e8832adeb725849c48e7c163b38e.digested.webp";